import { TpCanonicalTypeInfo, TpDataContext } from '../interfaces';
import {
  TpActiveEnSelectionFilter,
  TpEnSelectionFilterDefinition,
  TpEnSelectionFilterStep,
  TpEnSelectionFilterStepImport,
  TpEnSelectionFilterTypes,
} from './interfaces';
import { getEnSelectionFilterStep } from './selectionEnFilters';
import { TpUserEnSelectionAction, TpUserEnSelectionActionImport } from './userSelectionActions';

export function getImportEnFilterStep(
  selectionFilter: TpActiveEnSelectionFilter,
  key: string,
): TpEnSelectionFilterStepImport | null {
  const step = getEnSelectionFilterStep(selectionFilter, key);
  if (!step) return null;
  return step as TpEnSelectionFilterStepImport;
}

function getImportStepKey(assetName: string, assetId: string): string {
  return `importFilterStep_${assetName}_${assetId}`;
}

function handleUserAction(
  state: any,
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  userSelectionAction: TpUserEnSelectionAction,
) {
  const userSelectionActionImport = userSelectionAction as TpUserEnSelectionActionImport;
  const stepImport: TpEnSelectionFilterStepImport = {
    type: TpEnSelectionFilterTypes.IMPORT,
    description: userSelectionActionImport.description,
    key: getImportStepKey(userSelectionActionImport.assetName, userSelectionActionImport.assetId),
    selectedItemIds: userSelectionActionImport.selectedItemIds,
    assetId: userSelectionActionImport.assetId,
    assetName: userSelectionActionImport.assetName,
  };
  canonicalTypeInfo.selectionFilter.steps.push(stepImport);
}

function performStep(
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  step: TpEnSelectionFilterStep,
): any[] {
  const stepImport = step as TpEnSelectionFilterStepImport;
  return stepImport.selectedItemIds;
}

function renderContent(
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  step: TpEnSelectionFilterStep,
) {
  const stepImport = step as TpEnSelectionFilterStepImport;
  const subTitle = `Matched IDs from source to target dataset (Lasso/Manual steps converted to static snapshot).`;
  return (
    <span>
      <b>Imported ID Cohort (from {stepImport.assetName})</b>: {subTitle}
    </span>
  );
}

export const defEnSelectionFilterImport: TpEnSelectionFilterDefinition = {
  handleUserAction,
  performStep,
  renderContent,
};
